import React, { useEffect, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import './dashboard.css';
import TopBar from '../topbar/topbar';
import MainContainer from '../maincontainer/maincontainer';
import Footer from '../footer/footer';
import Sidebar from '../sidebar/sidebar';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProfileDetails from '../profile/profile';
import api from '../../services/api';
import InvestmentDetails from '../investments/investments';
import SecurityDetails from '../security/security';

const Dashboard: React.FC = () => {
  const [userProfile, setUserProfile] = useState({ userId: null, profile: null });
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await api.get('auth/users/profile');
        setUserProfile(response.data);
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };
    fetchProfileData();
  }, []);
  return (
    <Container fluid className="vh-100">
      <TopBar />
      <Row style={{ marginRight: 'auto' }}>
        {/* Menú lateral */}
        <Sidebar />
        {/* Contenido principal */}
        <Col md={9} className="content-area p-4">
          <Routes>
            <Route path="/" element={<MainContainer userProfile={userProfile} />} />
            <Route path="/*" element={<Navigate to="/dashboard" />} />
            <Route path="profile" element={<ProfileDetails userProfile={userProfile} />} />
            <Route path="investments" element={<InvestmentDetails userProfile={userProfile} />} />
            <Route path="security" element={<SecurityDetails userProfile={userProfile} />} />
          </Routes>
        </Col>
      </Row>
      <Footer />
    </Container>
  );
};

export default Dashboard;
